import {Box, Text} from '@mantine/core';
import Image from 'next/image';
import {type FC, useState} from 'react';
import {MdOutlineBookmark, MdOutlineBookmarkBorder} from 'react-icons/md';
import type {ColumnCardProps} from '.';
import FallbackThumbnail from '../../../../../public/next-image/engineer/column_default.png';
import {cn} from '../../../../lib/classname';
import {CommonLink} from '../../../../shared/components/CommonLink';

type Props = ColumnCardProps & {
  isFavorite: boolean;
  favoriteCount: number;
  handleClip: () => Promise<void>;
};
export const ColumnCardPresentation: FC<Props> = ({
  post,
  isSponsored,
  isFavorite,
  favoriteCount,
  handleClip,
  className,
}) => {
  return (
    <div
      key={post.id}
      className={cn(
        'flex flex-col justify-between w-[300px] pc:w-[375px]',
        className,
      )}
    >
      <CommonLink href={`/archives/${post.id}`} className="hover:opacity-60">
        <ColumnCardImage
          thumbnail={post.cardImageURL || post.carouselThumbnailURL}
          title={post.title}
        />
      </CommonLink>
      <div className="flex flex-col gap-y-4 pt-12">
        <Box className="flex justify-between items-center">
          {isSponsored ? (
            <Box className="rounded-full border-[1px] border-black-3 px-8 py-2">
              <Text className="text-sm text-black-3">Sponsored</Text>
            </Box>
          ) : (
            <Box />
          )}
          <Box
            className={`flex cursor-pointer p-4 items-center justify-center hover:opacity-80 border-2 border-primary-1 rounded-full ${
              isFavorite ? 'bg-primary-1 text-white' : 'text-primary-1'
            }`}
            onClick={handleClip}
          >
            {isFavorite ? (
              <MdOutlineBookmark size={20} />
            ) : (
              <MdOutlineBookmarkBorder size={20} />
            )}
            <Text className="text-sm mx-4">{favoriteCount}</Text>
          </Box>
        </Box>
        <CommonLink href={`/archives/${post.id}`} className="hover:opacity-60">
          <Text className="line-clamp-2 text-base font-bold">{post.title}</Text>
        </CommonLink>
      </div>
    </div>
  );
};

type ColumnCardImageProps = {
  thumbnail?: string;
  title: string;
  className?: string;
};

const ColumnCardImage: FC<ColumnCardImageProps> = ({
  thumbnail,
  title,
  className,
}) => {
  const [error, setError] = useState(false);

  if (error || !thumbnail) {
    return (
      <Image
        className={cn('w-full object-cover rounded-16', className)}
        src={FallbackThumbnail}
        alt={title}
        width={336}
        height={189}
      />
    );
  }
  return (
    <Image
      className={cn('w-full object-cover rounded-16', className)}
      src={thumbnail}
      alt={title}
      width={336}
      height={189}
      onError={() => setError(true)}
    />
  );
};
